<template>
  <v-tooltip content-class="opacity--1 cfs-tooltip" color="#535353" top>
    <template #activator="{ on, attrs }">
      <div>
        <v-img v-bind="attrs" :src="ImageFullfiled" :height="height" :width="width" v-on="on" />
      </div>
    </template>
    <span>{{ title }}</span>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { props as iconProps, useIcon } from '@/composables/icons/useIcon';
import ImageFullfiled from '@/assets/img/icons/indicators/icon-fulfilled.svg';

export default defineComponent({
  name: 'IconFulfilled',
  props: {
    ...iconProps,
    title: {
      type: String,
      default: 'Finalized',
    },
  },
  setup(props) {
    return {
      ImageFullfiled,
      ...useIcon(props),
    };
  },
});
</script>
